import React from "react";
import "./HeaderMobile.css";
import {ReactComponent as SancorLogo} from "../../../../assets/images/Sancor.svg";

const HeaderMobile = (props) => {

    return (
        <React.Fragment>
            <div
                className="backgroundSancor-mobile parent"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%"
                }}
            />
                <SancorLogo
                    style={{
                        marginRight: "auto",
                        display: "block",
                        height: "30px",
                        width: "auto",
                        position: "absolute",
                        top: "45px",
                        left: "16px",

                    }}
                    alt="sancor"
                />
            <div
                className="backgroundAffinity-mobile child"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "self-end",
                }}
            />
                <img
                    src={props.affinityPicture}
                    style={{
                        height: "64px",
                        width:"auto",
                        maxWidth: "40%",
                        objectFit: "contain",
                        position: "absolute",
                        top: "30px",
                        right:"24px"
                    }}
                    alt="sancor"
                />
        </React.Fragment>
    );
};

export default HeaderMobile;
